import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import {accessToken} from '@/methods/AccessToken.js';
import {isAdmin} from '@/methods/isAdmin.js';

Vue.use(Vuex)
Vue.use(VueCookies);

export default new Vuex.Store({
    state: {
        isLoggedIn: !!localStorage.getItem('access_token'),
        is_admin: isAdmin.get(),
        cart: null,
        downloading: false
    },
    getters: {
        isLoggedIn: state => {
            return state.isLoggedIn;
        },
        is_admin: state => {
            return state.is_admin;
        },
        cart_total: state => {
            const cart_total = state.cart ? state.cart.items.length : 0;
            return cart_total;
        },
        cart_ids: state => {
            if (state.cart) {
                const cart_ids = [];

                state.cart.items.forEach(element => {
                    cart_ids.push(element.id);
                });

                return cart_ids;
            }
            else {
                return null;
            }
        }
    },
    mutations: {
        login_success (state) {
            state.isLoggedIn = true;
        },
        is_admin (state, payload) {
            state.is_admin = payload;
        },
        logout (state) {
            state.isLoggedIn = false;
            state.is_admin = false;
        },
        load_cart (state) {
            // eslint-disable-next-line
            const cart = $cookies.get('cart') ? $cookies.get('cart') : {items: []};
            state.cart = cart;
        },
        downloading (state, payload) {
            state.downloading = payload
          }
    },
    actions: {
        login({commit, dispatch}, credentials) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    // eslint-disable-next-line
                    axios.post(process.env.VUE_APP_API_URL + '/oauth/token', {
                        grant_type: process.env.VUE_APP_PASSPORT_GRANT_TYPE,
                        client_id: process.env.VUE_APP_PASSPORT_CLIENT_ID,
                        client_secret: process.env.VUE_APP_PASSPORT_CLIENT_SECRET,
                        username: credentials.email,
                        password: credentials.password
                    })
                    .then(response => (
                        accessToken.set(JSON.stringify(response.data)),
                        dispatch('is_admin'),
                        commit('login_success'),
                        resolve()
                    ))
                    .catch(error => (
                        reject(error)
                    ))
                }, 1000);
            });
        },
        is_admin({commit}) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    // eslint-disable-next-line
                    axios.get(process.env.VUE_APP_API_URL + '/api/user/')
                    .then(response => (
                        isAdmin.set(!!+response.data['is_admin']),
                        commit('is_admin', !!+response.data['is_admin']),
                        resolve()
                    ))
                    .catch(error => (
                        reject(error)
                    ))
                }, 1000);
            });
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    // eslint-disable-next-line
                    axios.delete(process.env.VUE_APP_API_URL + '/api/user/logout')
                    .then(
                        accessToken.delete(),
                        isAdmin.delete(),
                        commit('logout'),
                        resolve()
                    )
                    .catch(error => (
                        reject(error)
                    ))
                }, 1000);
            });
        }
    }
})